<template>
    <v-card outlined class="mx-auto my-4">
      <v-card-title class="d-flex align-center text-body-2">
          <span>{{ item.pathname }}</span>
          <!-- Small spinner indicating that it's pending -->
        </v-card-title>
        <v-card-subtitle class="d-flex align-center">
            <span>{{ item.urlType }}</span>
        <!-- Chip to clearly indicate waiting state -->
        <v-chip :color="fetchColor" outlined small class="ml-2">
        {{ fetchText }}
      </v-chip>
      </v-card-subtitle>
      <v-chip :color="sitemapColor" outlined small class="ml-2">
        {{ item.isSitemap ? 'Sitemap' : 'Not Sitemap' }}
      </v-chip>
      <v-card-actions>
        <v-btn color="primary" @click="openUrl">
          Open URL
        </v-btn>
      </v-card-actions>
    </v-card>
  </template>
  
  <script setup lang="ts">
  import { computed } from 'vue';
  import { useActiveUrlStore } from '@/store/activeUrlStore';
  import IUrl from '@/interfaces/IUrl';
  import { getFetchStatusColor, getFetchStatusText } from '@/helpers/fetchStatusHelper';
  
  interface Props {
    item: IUrl;
  }
  
  const props = defineProps<Props>();
  const activeUrlStore = useActiveUrlStore();
  
  function openUrl() {
    const fullUrl = activeUrlStore.getUrlByPathname(props.item.pathname);
    window.open(fullUrl, '_blank');
  }

  const fetchColor = computed(() => {
    return getFetchStatusColor(props.item.fetchStatus);
  });

  const fetchText = computed(() => {
    return getFetchStatusText(props.item.fetchStatus);
  });

  const sitemapColor = computed(() => {
    return props.item.isSitemap ? "success" : "error";
  });
  </script>
  